<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-30 17:02:04
 * @LastEditors: geory
 * @LastEditTime: 2025-08-14 10:58:32
-->
<template>
  <div
    class="contentImgItem"
    contenteditable="false"
    :style="{ 'background-image': 'url(' + src + ')' }"
  >
    <img
      class="contentImgItemDel"
      :style="{
        'background-image':
          'url(' +
          'https://imagessl.lingtuo.cn/A-1ed71af7_20250813145017.png' +
          ')',
      }"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "editorFile",
  props: ["type", "src"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style></style>
